// context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import axios from "axios";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const loadUser = async () => {
    try {
      const savedUser = localStorage.getItem("user");
      const token = localStorage.getItem("token");
      if (savedUser && token) {
        setUser(JSON.parse(savedUser));
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      }
    } catch (err) {
      console.error("[AuthContext] Failed to parse stored user:", err);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    } finally {
      setLoading(false);
    }
  };
  loadUser();
}, []);

  const login = (userData, token) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    delete axios.defaults.headers.common["Authorization"];
    // navigate("/");
  };

const updateUser = (updatedData) => {
  if (!user) return;

  // ✅ If a full user object is passed (has _id), replace entirely
  // If partial data is passed, merge it
  const updated = updatedData?._id
    ? updatedData                    // full replacement — use as-is
    : { ...user, ...updatedData };   // partial patch — merge
  // console.log("Updating user in context:", updated);

  setUser(updated);
  localStorage.setItem("user", JSON.stringify(updated));
};

const refreshUser = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return;

    const res = await api.get("/users/me"); // ✅ FIXED

    const updatedUser = res.data.user;

    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));

    return updatedUser;
  } catch (error) {
    console.error("Failed to refresh user:", error);
    logout();
  }
};

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, refreshUser, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};